/**
 * @fileoverview DELETE handler for the "/engagement/report_tile/:tile_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportTileTileIdCacheKeys } from "./constants";
import type {
  DeleteEngagementReportTileTileIdProps,
  EmptyResult as EngagementReportTileDeleteTileResult,
} from "./types";

export const deleteEngagementReportTileTileId = reactQueryMutationAdapter(
  engagementReportTileTileIdCacheKeys,
  (props: DeleteEngagementReportTileTileIdProps): Promise<EngagementReportTileDeleteTileResult> => {
    return fetch(`/engagement/report_tile/${props.tileId}`, "DELETE", { dashboard_id: props.dashboard_id });
  }
);
